import React, { useCallback, useRef, useEffect, } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import { makeStyles, } from '@material-ui/styles'
import classNames from 'classnames'
import ClassNameTypes from '@shapr/react-shared/types/ClassName'
import AsyncType, { AsyncState, } from '@shapr/react-shared/types/Async'
import CircularProgress from '@material-ui/core/CircularProgress'
import Box from '@material-ui/core/Box'

const Login = props => {
  const {
    className,
    onLogin,
    token,
    onTokenChange,
    validateTokenStatus,
    validateTokenMessage,
  } = props
  const classes = useStyles()

  const handleSubmit = useCallback(
    e => {
      e.preventDefault()
      onLogin(token)
    },
    [onLogin, token,],
  )
  const handleTokenChange = useCallback(e => {
    onTokenChange(e.target.value)
  }, [])

  const tokenInputRef = useRef()
  useEffect(() => {
    tokenInputRef.current.focus()
  }, [])

  return (
    <form
      onSubmit={handleSubmit}
      className={classNames(classes.root, className)}
    >
      <TextField
        value={token}
        onChange={handleTokenChange}
        label="Token"
        margin="normal"
        variant="outlined"
        required
        inputRef={tokenInputRef}
      />
      {validateTokenStatus === AsyncState.fail && !!validateTokenMessage && (
        <Typography variant="body1" className={classes.errorMessage}>
          {validateTokenMessage}
        </Typography>
      )}
      {validateTokenStatus === AsyncState.pending && (
        <Box display="flex" justifyContent="center">
          <CircularProgress size={36} />
        </Box>
      )}
      {validateTokenStatus !== AsyncState.pending && (
        <Button type="submit">Login</Button>
      )}
    </form>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  errorMessage: {
    color: theme.palette.error.main,
  },
}))

Login.propTypes = {
  className: ClassNameTypes.isRequired,
  onLogin: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  onTokenChange: PropTypes.func.isRequired,
  validateTokenStatus: AsyncType.isRequired,
  validateTokenMessage: PropTypes.string,
}

export default React.memo(Login)
